<template>
    <div>
        <v-card class="pa-5 margin-bottom">
            <v-row class="mx-2 mt-0 pt-0">
                <v-col cols="12" class="mt-0 pt-0">
                    <h1>Stations report</h1>
                </v-col>
            </v-row>
            <v-row class="mx-2 mt-0 pt-0">
                <v-col cols="12" class="text-center mt-0 pt-0">
                    <v-btn class="mt-4 generate-btn-margin" small color="success" @click="handleGenerateClick"
                        >Generate current data
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>

        <!-- LIST part -->
        <v-card>
            <v-flex style="overflow: auto">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-options': [5, 10, 20],
                    }"
                    item-key="id"
                    :options.sync="options"
                    :loading="loading"
                    loading-text="Loading stations"
                    :page="stationsTableOptions && stationsTableOptions.page ? stationsTableOptions.page : 1"
                    :server-items-length="itemsCount"
                    class="elevation-1 data-analysis-table"
                >
                    <template v-slot:item="{ item }">
                        <tr :key="`da_row_${item.id}`">
                            <td class="text-center">{{ item.id ? item.id : '-' }}</td>
                            <td class="text-center">{{ item.created_at ? item.created_at : '-' }}</td>
                            <td class="text-center">
                                {{ item.count ? item.count : '-' }}
                            </td>
                            <td class="text-center">
                                <v-chip
                                    :color="
                                        item.status === 'finished'
                                            ? 'success'
                                            : item.status === 'error'
                                            ? 'error'
                                            : 'grey lighten-2'
                                    "
                                >
                                    {{ item.status | cleanString }}
                                </v-chip>
                            </td>
                            <td class="text-center">
                                <v-icon v-if="item.status === 'finished'" @click="handleDownloadCsvFile(item.id)">
                                    mdi-download
                                </v-icon>
                                <v-icon v-else @click="handleRefresh()">
                                    mdi-refresh
                                </v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'StationsList',
    data() {
        return {
            options: {},
            loading: false,

            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Created at',
                    align: 'center',
                    sortable: false,
                    value: 'created_at',
                },
                {
                    text: 'Stations count',
                    align: 'center',
                    sortable: false,
                    value: 'count',
                },
                {
                    text: 'Status',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                },
                {
                    text: 'Download',
                    align: 'center',
                    sortable: false,
                    value: 'download',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true
        await this.getStationsData()
        this.loading = false
    },
    computed: {
        ...mapState('report', ['stationsTableOptions', 'stations', 'stationsCount']),
        items() {
            return this.stations || []
        },
        itemsCount() {
            return this.stationsCount || 0
        },
    },
    watch: {
        options(val) {
            this.setStationsTableOptions(val)
        },
    },
    components: {},
    methods: {
        ...mapActions('report', ['generateCsvFile', 'downloadCsvFile', 'getStationsData']),
        ...mapMutations('report', ['setStationsTableOptions']),

        async handleGenerateClick() {
            await this.generateCsvFile({ type: 'stations' })
            await this.getStationsData()
        },

        async handleDownloadCsvFile(itemId) {
            const response = await this.downloadCsvFile(itemId)
            if (!response) {
                return
            }
            const url = window.URL.createObjectURL(new Blob([response]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${itemId}.csv`)
            document.body.appendChild(link)
            link.click()
        },

        async handleRefresh() {
            await this.getStationsData()
        },
    },
}
</script>

<style scoped></style>
